import { Button, Card, Col, Flex, Row, Select, Tabs, Typography } from "antd";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import ArrowLeftCircleIcon from "../../../../../Theme/CustomIcons/Icons/Arrow/ArrowLeftCircleIcon";
import ArrowCircleDownIcon from "../../../../../Theme/CustomIcons/Icons/Arrow/ArrowCircleDownIcon";
import DetailsPage from "./Pages/DetailsPage";
import ModulesPage from "./Pages/ModulesPage";
import { dummyEntityAuditLogs, dummyEntityComments } from "./DummyData";
import ArrowCircleRight2Icon from "../../../../../Theme/CustomIcons/Icons/Arrow/ArrowCircleRight2Icon";
import ArrowCircleLeft2Icon from "../../../../../Theme/CustomIcons/Icons/Arrow/ArrowCircleLeft2Icon";
import CustomLoaderIcon from "../../../../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";

const { Text } = Typography;

const EntityDetailView = ({
  entityId,
  onBackToList,
  allEntities,
  onEntityChange,
  onPrev,
  onNext,
  loading,
}) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  const isLightBg = themeDefault?.info?.themeColor === "default";
  const [activeTab, setActiveTab] = useState("details");

  const entities = useMemo(() => {
    return Array.isArray(allEntities) ? allEntities : [];
  }, [allEntities]);

  const entity = useMemo(() => {
    if (!entities || entities.length === 0) return null;
    return (
      entities.find((e) => (e._id || e.id || e.name) === entityId) ||
      entities[0]
    );
  }, [entities, entityId]);

  const currentIndex = useMemo(() => {
    return entities.findIndex((e) => (e._id || e.id || e.name) === entityId);
  }, [entities, entityId]);

  const totalCount = entities.length;

  const handleEntityChange = (newEntityId) => {
    if (onEntityChange) onEntityChange(newEntityId);
  };

  const headerTitle = entity?.entityName || entity?.name || "Entity";

  const Overview = () => (
    <Card>
      <Text type="secondary">Overview content placeholder</Text>
    </Card>
  );

  const tabItems = [
    { key: "overview", label: "Overview", children: <Overview /> },
    {
      key: "details",
      label: "Details",
      children: (
        <DetailsPage
          entity={entity}
          entityId={entityId}
          auditLogs={dummyEntityAuditLogs}
          comments={dummyEntityComments}
        />
      ),
    },
    {
      key: "modules",
      label: "Modules",
      children: <ModulesPage entityId={entityId} />,
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Card>
          <Flex align="center" gap="middle" style={{ marginBottom: 16 }}>
            <ArrowLeftCircleIcon onClick={onBackToList} />
            <Flex
              align="center"
              justify="space-between"
              style={{ width: "100%" }}
            >
              <Flex vertical gap={4}>
                <span style={{ fontSize: 10, fontWeight: 700 }}>Entity</span>
                <Select
                  style={{
                    minWidth: 250,
                    color: themeDefault?.info?.colorPrimary,
                    border: "none",
                  }}
                  value={entityId}
                  onChange={handleEntityChange}
                  showSearch
                  suffixIcon={
                    <ArrowCircleDownIcon
                      size="small"
                      color={isLightBg ? "#000000" : "#ffffff"}
                    />
                  }
                  filterOption={(input, option) => {
                    const ent = entities.find(
                      (e) => (e._id || e.id) === option?.value
                    );
                    const name = ent?.entityName || ent?.name || "";
                    return name.toLowerCase().includes(input.toLowerCase());
                  }}
                  options={entities.map((e) => ({
                    value: e._id || e.id || e.name,
                    label: (
                      <Flex align="center" gap="small">
                        <div>
                          <div style={{ fontWeight: 500 }}>
                            {e.entityName || e.name}
                          </div>
                        </div>
                      </Flex>
                    ),
                  }))}
                />
              </Flex>

              {totalCount > 0 && (
                <Flex vertical gap={4} align="end" style={{ width: "100%" }}>
                  <span
                    style={{ fontSize: 10, fontWeight: 700, paddingRight: 4 }}
                  >
                    {Math.max(currentIndex + 1, 1)}/{totalCount}
                  </span>
                  <Flex align="center" gap={8}>
                    <ArrowCircleLeft2Icon onClick={onPrev} />
                    <ArrowCircleRight2Icon onClick={onNext} />
                  </Flex>
                </Flex>
              )}
            </Flex>
          </Flex>
        </Card>

        {loading ? (
          <div
            style={{ display: "flex", justifyContent: "center", padding: 24 }}
          >
            <CustomLoaderIcon />
          </div>
        ) : (
          <Tabs
            style={{ marginTop: 16 }}
            items={tabItems}
            activeKey={activeTab}
            onChange={(key) => setActiveTab(key)}
            defaultActiveKey="overview"
          />
        )}
      </Col>
    </Row>
  );
};

export default EntityDetailView;
